<template>
  <el-dialog
    class="successDialog"
    :visible.sync="show"
    width="420px"
    :show-close="false"
  >
    <div class="flex flex-col items-center">
      <p class="message">{{ message }}</p>
    </div>
    <div class="formtext">
      <el-form ref="form" :rules="rules" :model="formDate" label-width="100px">
        <el-form-item
          label-position="top"
          label-width="100"
          :label="this.label"
          prop="reason"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 10 }"
            v-model="formDate.reason"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex justify-center mt-5">
      <el-button
        v-if="confirmvisible"
        size="small"
        type="primary"
        @click="Confirm"
        >{{ $t("btn.confirm") }}</el-button
      >
      <el-button size="small" class="clo" type="primary" @click="close">{{
        $t("btn.close")
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { juptResetSign } from "@/services";
export default {
  name: "jupuResetDialog",
  props: {
    // 船舶的传值
    createdtable: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      message: "Reset Signature",
      label: "Reason for Resetting",
      show: false,
      userTypes: "",
      formDate: {
        reason: "",
      },
      rules: {
        reason: [{ required: true, message: "", trigger: "blur" }],
      },
      confirmvisible: true,
    };
  },
  created() {
    this.userTypes = this.$store.state.userInfo.userType;
  },
  methods: {
    open() {
      this.show = true;
    },
    Confirm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          juptResetSign({
            id: this.$route.query.id,
            reason: this.formDate.reason,
          }).then((res) => {
            if (res.code == 200) {
              this.close();
              this.$router.push({
                url: "/barging/index",
                query: {
                  id: this.$route.query.id,
                  pageStatus: 0,
                },
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    close() {
      this.show = false;
      // this.$emit("upup", this.userTypes);
    },
  },
};
</script>

<style lang="scss">
.successDialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 20px;
  }
  .el-dialog {
    border-radius: 10px;
  }
  .formtext {
    margin-top: 20px;
  }
  .message {
    font-size: 18px;
    text-align: center;
    color: #82889c;
    margin-top: 10px;
  }
  .clo {
    background: #fff;
    color: #008CDB;
  }
}
</style>
